import { Order, OrderItem, HopOrder } from "@/pages/orders/orders.types";

export enum OrderStatus {
  NEW = "NEW",
  PROCESSING = "PROCESSING",
  DELIVERED = "DELIVERED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum CancellationReason {
  NO_LONGER_NEEDED = "No longer needed",
  ORDERED_BY_MISTAKE = "Ordered by mistake",
  SWITCHING_TO_DIFFERENT_ASSET = "Switching to a different asset",
  OTHER = "Other",
}

export interface CancellationState {
  isLoading: boolean;
  error: string | null;
}

export interface OrderDetails {
  orderId: string;
  orderReference: string;
  assetName: string;
  requestDate: string;
}

const CANCELLABLE_STATUSES: string[] = [OrderStatus.NEW, OrderStatus.PROCESSING];
const HOP_CANCELLABLE_STATUS = "ready-for-export";

export function isCancellableStatus(status?: string): boolean {
  if (!status) return false;
  return CANCELLABLE_STATUSES.includes(status.toUpperCase());
}

export function isHopCancellable(items?: OrderItem[]): boolean {
  if (!items || items.length === 0) return true;
  const allHopOrders = items.flatMap((item) => item.details?.hopOrders ?? []);
  if (allHopOrders.length === 0) return true;
  return allHopOrders.every((hop: HopOrder) => !hop.status || hop.status === HOP_CANCELLABLE_STATUS);
}

export function shouldHideCancelButton(status?: string): boolean {
  return status?.toUpperCase() === OrderStatus.CANCELLED;
}

export function extractOrderDetails(order: Order): OrderDetails {
  const firstItem = order.items?.[0];
  const assetName = firstItem?.itemInformation?.name ?? "Unknown Asset";
  return {
    orderId: order.orderId ?? "",
    orderReference: order.orderReference ?? "",
    assetName,
    requestDate: order.requested?.on ? new Date(order.requested.on).toLocaleDateString() : "Unknown",
  };
}
